import { startCase } from 'lodash';

export default function capitalizeText(str: string) {
  return startCase(String(str).toLowerCase());
}
